<template>
    <div v-show="isOpen" v-bind="$attrs">
        <div class="content">
            <slot v-bind="this" />
        </div>
        <div class="mask" v-show="!disableMask" v-on:click="backdropClick()"></div>
    </div>
</template>

<script>
    import { dialogComponent } from 'BASE/plugins/dialogPlugin';
    export default {
        mixins: [dialogComponent],
        data() {
            return {
                defOptions: {
                    title: '温馨提示',
                    warningAutoHideLength: 3
                },
                successKeyWord:[
                    "成功",
                    "已设定",
                    "已绑定",
                    "已将方案加至购注区",
                    "已提交",
                    "已启用",
                    "已重置",
                    "已设置",
                    "敬请期待",
                    "祝您中奖",
                    "恭喜中奖",
                    "微信绑定解除!!",
                    "订单已送出"
                ],
                warningKeyWord:[
                    "投注时请注意期号",
                ],
            }
        },
        methods: {
            removeDialogClass() {
                document.body.classList.remove('v-dialog-show');
                document.body.style.paddingRight = '';
            },
            containSuccessKeyWord(){
                this.removeDialogClass();   //輕圖示視窗不限制視窗拖異

                let _this = this;
                if(typeof _this.data.message !== "string"){
                    return "i_error";
                }

                for(let i = 0; i < _this.successKeyWord.length; i++){
                    if(_this.data.message.indexOf(_this.successKeyWord[i]) >= 0){
                        return "i_success";
                    }
                }

                for(let i = 0; i < _this.warningKeyWord.length; i++){
                    if(_this.data.message.indexOf(_this.warningKeyWord[i]) >= 0){
                        return "i_warning";
                    }
                }

                return "i_error";
            }
        },
    };
</script>